import type { Subscription, SubscriptionApiItem } from './subscriptions-query';
import {
    SUBSCRIPTION_LIST_ID,
    SUBSCRIPTION_TAG,
    transformSubscription,
} from './subscriptions-query';

export type UpdateSubscriptionInput = {
    id: string;
    subscriptionName: string;
    customerName: string;
    companyName: string;
    salesforceLink: string;
    comment: string;
    capacityGroupId: string;
    capacityGroupName: string;
};

type UpdateSubscriptionResponse = {
    subscription?: SubscriptionApiItem;
};

export const updateSubscriptionMutation = {
    query: ({ id, ...fields }: UpdateSubscriptionInput) => ({
        url: `/mp/1/subscriptions/${id}`,
        method: 'put',
        body: { subscription: { id, ...fields } },
    }),
    transformResponse: (
        response: UpdateSubscriptionResponse,
        _meta: unknown,
        arg: UpdateSubscriptionInput,
    ): Subscription => {
        const sub = response?.subscription ?? {};
        return transformSubscription({ ...sub, id: sub.id ?? arg.id });
    },
    invalidatesTags: (
        _result: Subscription | undefined,
        _error: unknown,
        arg: UpdateSubscriptionInput,
    ) => [
        { type: SUBSCRIPTION_TAG, id: arg.id },
        { type: SUBSCRIPTION_TAG, id: SUBSCRIPTION_LIST_ID },
    ],
};
